import { render, staticRenderFns } from "./IntentExamplesHeaderBulkMove.vue?vue&type=template&id=a50c98fc&"
import script from "./IntentExamplesHeaderBulkMove.vue?vue&type=script&lang=js&"
export * from "./IntentExamplesHeaderBulkMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports